import { isValidCenter } from '../../utils/isValidCenter';
export { isValidCenter };

export function toLatLng(center) {
  return { lat: center[0], lng: center[1] };
}

export function selectPrimaryCenter(workCenter, homeCenter) {
  if (isValidCenter(workCenter)) return workCenter;
  if (isValidCenter(homeCenter)) return homeCenter;
  return null;
}

export function toRoundedOsmGridCenter(center) {
  if (!isValidCenter(center)) {
    return { osmLat: null, osmLng: null };
  }

  return {
    osmLat: Math.round(center[0] * 10) / 10,
    osmLng: Math.round(center[1] * 10) / 10,
  };
}

export function normalizeArrayProp(value) {
  return Array.isArray(value) ? value : [];
}

export function resolveMapColorScheme(mapLayer, isDarkTheme) {
  if (mapLayer === 'satellite') return 'LIGHT';
  return isDarkTheme ? 'DARK' : 'LIGHT';
}

export function resolveGoogleMapTypeId(mapLayer) {
  return mapLayer === 'satellite' ? 'satellite' : 'roadmap';
}

export function resolveLoadingReadiness({ showThingsToDo, hotSprings, showCrimeLayer, fullGeoJson }) {
  return {
    thingsToDoReady: showThingsToDo ? hotSprings !== null : undefined,
    safetyReady: !showCrimeLayer || fullGeoJson != null,
  };
}
